/* GERMAG Early Black Friday. Isolated UI; Shopify is the price/stock authority. */
(() => {
  function init(root) {
    if (root.dataset.ebfReady) return;
    root.dataset.ebfReady = 'true';
    const base = window.Shopify?.routes?.root || '/';
    const currency = window.Shopify?.currency?.active || 'RON';
    const deadline = /(?:Z|[+-]\d{2}:\d{2})$/.test(root.dataset.endAt || '') ? Date.parse(root.dataset.endAt) : NaN;
    let ended = false;
    let timer;
    let productInterval;
    function expire() {
      ended = true;
      clearInterval(timer);
      clearInterval(productInterval);
      if (root.dataset.expiryMode === 'hide') { root.hidden = true; return; }
      const panel = document.createElement('section');
      panel.className = 'ebf-ending';
      const heading = document.createElement('h2'); heading.textContent = 'Campania Early Black Friday s-a încheiat.';
      const text = document.createElement('p'); text.textContent = 'Descoperă produsele disponibile acum pe GERMAG.';
      const link = document.createElement('a'); link.href = base; link.className = 'ebf-button'; link.textContent = 'Vezi selecția actuală →';
      const cartLink = document.createElement('a'); cartLink.href = root.dataset.cartUrl || `${base}cart`; cartLink.className = 'ebf-button'; cartLink.textContent = 'Vezi coșul →';
      panel.append(heading, text, link, cartLink);
      root.replaceChildren(panel);
    }
    if (Number.isFinite(deadline) && Date.now() >= deadline) { expire(); return; }
    const money = cents => new Intl.NumberFormat('ro-RO', { style: 'currency', currency }).format(cents / 100).replace('RON', 'lei');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prices = new Map();
    const refreshTotals = () => root.querySelectorAll('[data-ebf-form]').forEach(form => {
      const select = form.querySelector('[data-ebf-clock-select]');
      if (!select) return;
      const total = form.querySelector('[data-ebf-bundle-total]');
      const main = prices.get(String(form.elements.id.value));
      const clock = prices.get(select.value);
      total.hidden = !select.value || !main || !clock;
      if (!total.hidden) total.textContent = `Boxă + ceas: ${money(main.price + clock.price)}`;
      const button = form.querySelector('[type="submit"]');
      if (button && button.getAttribute('aria-busy') !== 'true' && !button.disabled) button.textContent = select.value ? 'Adaugă boxa + ceasul' : 'Adaugă în coș +';
    });
    root.querySelectorAll('[data-ebf-clock-select]').forEach(select => { select.disabled = false; select.addEventListener('change', refreshTotals); });
    const motion = root.querySelector('[data-ebf-motion]');
    motion?.addEventListener('click', () => {
      const paused = root.classList.toggle('ebf--paused');
      motion.setAttribute('aria-pressed', String(paused));
      motion.textContent = paused ? 'Pornește animațiile' : 'Pauză animații';
    });
    root.querySelectorAll('a[href^="#ebf-"]').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    }));
    const toast = root.querySelector('.ebf-toast');
    let toastTimeout;
    root.querySelector('[data-ebf-dismiss]')?.addEventListener('click', () => { toast.hidden = true; });
    const notify = text => {
      if (ended) return;
      const message = root.querySelector('[data-ebf-toast-text]');
      if (!message || !toast) return;
      message.textContent = text;
      toast.hidden = false;
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => { toast.hidden = true; }, 9000);
    };
    async function refreshProducts() {
      if (ended) return;
      const handles = [...new Set([...root.querySelectorAll('[data-ebf-product]')].map(el => el.dataset.handle).concat([...root.querySelectorAll('[data-clock-handle]')].map(el => el.dataset.clockHandle)))];
      const latest = new Map();
      await Promise.allSettled(handles.map(async handle => {
        const res = await fetch(`${base}products/${encodeURIComponent(handle)}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const product = await res.json();
        product.variants.forEach(v => {
          prices.set(String(v.id), v);
          root.querySelectorAll('[data-ebf-clock-select] option').forEach(option => {
            if (option.value !== String(v.id)) return;
            const color = String(v.id) === '51137978237206' ? 'Roz' : 'Galben';
            option.disabled = !v.available;
            option.textContent = v.available ? `${color} · +${money(v.price)}` : `${color} · Stoc epuizat`;
            if (!v.available && option.selected) { option.parentElement.value = ''; }
          });
        });
        root.querySelectorAll('[data-ebf-product]').forEach(card => {
          if (card.dataset.handle !== handle) return;
          const variant = product.variants.find(v => String(v.id) === card.dataset.variantId);
          if (!variant) return;
          latest.set(String(variant.id), variant);
          const price = card.querySelector('[data-ebf-price]');
          if (price) {
            const unit = price.querySelector('small');
            price.textContent = money(variant.price) + ' ';
            if (unit) price.append(unit);
          }
          const discounted = Number(variant.compare_at_price) > variant.price;
          const percent = discounted ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
          card.querySelectorAll('[data-ebf-discount]').forEach(badge => { badge.hidden = !discounted; badge.textContent = `−${percent}%`; });
          card.querySelectorAll('[data-ebf-reference]').forEach(reference => {
            reference.hidden = !discounted;
            reference.querySelector('[data-ebf-compare]').textContent = discounted ? money(variant.compare_at_price) : '';
            reference.querySelector('[data-ebf-saving]').textContent = discounted ? `Economisești ${money(variant.compare_at_price - variant.price)}` : '';
          });
          const stock = card.querySelector('[data-ebf-stock]');
          if (stock) stock.textContent = variant.available ? '● În stoc' : 'Stoc epuizat';
          const button = card.querySelector('[type="submit"]');
          if (button && button.getAttribute('aria-busy') !== 'true') {
            button.disabled = !variant.available;
            button.textContent = variant.available ? 'Adaugă în coș +' : 'Stoc epuizat';
          }
          card.classList.toggle('ebf-card--sold', !variant.available);
        });
      }));
      const maxWrap = root.querySelector('[data-ebf-max-wrap]');
      if (maxWrap) {
        // Do not advertise an unverified maximum if any product refresh failed.
        const expected = new Set([...root.querySelectorAll('[data-ebf-product]')].map(card => card.dataset.variantId));
        const complete = [...expected].every(id => latest.has(id));
        let maximum = 0;
        if (complete) latest.forEach(v => {
          if (v.available && v.compare_at_price > v.price) maximum = Math.max(maximum, Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price));
        });
        maxWrap.hidden = !complete || maximum === 0;
        if (maximum) root.querySelector('[data-ebf-max-discount]').textContent = `−${maximum}%`;
      }
      const pink = latest.get('51137978237206');
      const yellow = latest.get('51137896055062');
      const headline = root.querySelector('[data-ebf-clock-headline]');
      if (headline && pink && yellow) {
        headline.textContent = pink.price === yellow.price ? money(pink.price) : 'Vezi ofertele';
        if (pink.price === yellow.price) { const unit = document.createElement('small'); unit.textContent = '/ buc.'; headline.append(unit); }
      }
      refreshTotals();
    }
    root.querySelectorAll('[data-ebf-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      if (ended || (Number.isFinite(deadline) && Date.now() >= deadline)) { expire(); return; }
      const button = form.querySelector('[type="submit"]');
      if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
      const error = form.querySelector('.ebf-form-error');
      const label = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Se adaugă…';
      error.hidden = true;
      try {
        const items = [{ id: Number(form.elements.id.value), quantity: 1 }];
        const clockSelect = form.querySelector('[data-ebf-clock-select]');
        if (clockSelect?.value) items.push({ id: Number(clockSelect.value), quantity: 1 });
        const res = await fetch(`${base}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Produsul nu a putut fi adăugat. Verifică disponibilitatea și încearcă din nou.');
        notify(items.length === 2 ? 'Boxa și ceasul au fost adăugate în coș.' : 'Produs adăugat în coș.');
        // Updating presentation cannot turn a committed cart write into a reported failure.
        try {
          const html = data.sections?.['cart-drawer'];
          if (html) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const current = document.getElementById('cart-drawer-content');
            const next = parsed.getElementById('cart-drawer-content');
            if (current && next) current.replaceWith(next);
          }
          const cartResponse = await fetch(`${base}cart.js`, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          }
        } catch { /* The success toast retains a direct, freshly loaded cart link. */ }
      } catch (e) {
        error.textContent = e instanceof TypeError ? 'Conexiunea s-a întrerupt. Verifică mai întâi coșul înainte să încerci din nou.' : (e.message || 'Verifică mai întâi coșul înainte să încerci din nou.');
        error.hidden = false;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        refreshProducts();
      }
    }));
    // One campaign-wide absolute deadline; the campaign closes when it expires.
    const countdown = root.querySelector('[data-ebf-countdown]');
    if (Number.isFinite(deadline)) {
      const tick = () => {
        const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        if (seconds <= 0) { expire(); return; }
        if (!countdown) return;
        countdown.hidden = false;
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor(seconds % 86400 / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        root.querySelector('[data-ebf-time]').textContent = `${String(days).padStart(2, '0')}z ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds % 60).padStart(2, '0')}s`;
        root.querySelector('[data-ebf-end-label]').textContent = `Până la ${new Intl.DateTimeFormat('ro-RO', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Bucharest' }).format(deadline)}`;
      };
      tick(); timer = setInterval(tick, 1000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
    }
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshProducts(); });
    refreshProducts();
    productInterval = setInterval(() => { if (!document.hidden) refreshProducts(); }, 60000);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { clearInterval(productInterval); clearInterval(timer); clearTimeout(toastTimeout); }
    });
  }
  document.querySelectorAll('[data-ebf-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ebf-root]').forEach(init));
})();
